// Modules
import Link from 'next/link';
import Head from 'next/head';
import { Swiper, SwiperSlide } from 'swiper/react';
// Components
import MyImage from '~/components/my-image';
import CategoryPostsSection from '~/components/category-posts-section';
import CategoryPageTitle from '~/components/category-page-title';
import CategoryInfo from '~/components/category-info';
// Utils
import { isEmpty } from '~/utils';
import api from '~/services/api';
import actions from '~/services/log-actions';
// Styles
import styles from './category-page.module.scss';

const CategoryPage = ({ slug, categoryResponse, subCategoryResponse }) => {
  const {
    cover_image,
    alt_cover_image,
    title: pageTitle,
    content,
    childs: children = [],
  } = categoryResponse;

  const handleClickSubCategory = (title) => {
    api.sendLog(actions.SUBCATEGORY_BANNER_CLICK, { category: pageTitle, title });
  };

  const collectionPageScheme = JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'CollectionPage',
    name: pageTitle,
    url: `${process.env.SITE_URL}/category/${slug}/`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'خانه',
          item: `${process.env.SITE_URL}/`,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: pageTitle,
          item: `${process.env.SITE_URL}/category/${slug}/`,
        },
      ],
    },
    mainEntity: {
      '@type': 'ItemList',
      itemListOrder: 'https://schema.org/ItemListOrderUnordered',
      itemListElement: children?.map((item) => ({
        '@type': 'ListItem',
        item: {
          '@type': 'VideoObject',
          name: item.title,
          thumbnailUrl: item.cover_image || item.cover_image_url,
          description: item.content,
          uploadDate: item.created_at,
          contentUrl: item.download_link_720,
        },
      })),
    },
  });

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: collectionPageScheme }}
        />
      </Head>

      <div className={styles['wrapper']}>
        <div className={`${styles['wrapper__info']} container`}>
          <CategoryPageTitle
            coverImage={cover_image}
            altCoverImage={alt_cover_image}
            title={pageTitle}
          />

          <div className={styles['wrapper__info__bottom']}>
            <Swiper slidesPerView={'auto'}>
              {children?.map(
                (item, index) =>
                  subCategoryResponse[index].length > 0 && (
                    <SwiperSlide
                      key={item.id}
                      style={{ width: 'auto' }}
                      className={styles['wrapper__info__bottom__item']}
                    >
                      <Link
                        rel="preload"
                        href={item.slug}
                        title={item.title}
                        onClick={() => handleClickSubCategory(item.title)}
                      >
                        <MyImage src={item.cover_image} />
                      </Link>
                    </SwiperSlide>
                  )
              )}
            </Swiper>
          </div>
        </div>

        {children?.map(
          (row, index) =>
            subCategoryResponse[index].length > 0 && (
              <CategoryPostsSection
                key={index}
                items={subCategoryResponse[index]}
                title={row.title}
                slug={row.slug}
                rowType={row.row_type}
              />
            )
        )}
      </div>
      {!isEmpty(content) && <CategoryInfo data={content} />}
    </>
  );
};

export default CategoryPage;
